module.exports = __webpack_public_path__ + "static/img/construction-img.cb4c6b8.png";